import { Icon, Sidebar, Menu, Popup } from 'semantic-ui-react';
import React from 'react';
import PropTypes from 'prop-types';
import { useTextResources } from '../../../language';

const SideBar = ({ items, visible, onHide, children }) => {
  const text = useTextResources();

  return (
    <Sidebar.Pushable style={{ display: 'flex' }}>
      <Sidebar
        icon
        as={Menu}
        animation='overlay'
        onHide={onHide}
        vertical
        visible={visible}
        width='very thin'
      >
        {items.map(({ id, iconName, toolTip, cb }) => (
          <Popup
            key={id}
            position='right center'
            trigger={
              <Menu.Item onClick={cb}>
                <Icon
                  name={iconName}
                  style={{ color: '#004F75' }}
                  size='large'
                />
              </Menu.Item>
            }
            content={text(toolTip)}
          />
        ))}
      </Sidebar>
      <Sidebar.Pusher style={{ padding: '0 5em', flex: 1 }}>
        {children}
      </Sidebar.Pusher>
    </Sidebar.Pushable>
  );
};

SideBar.propTypes = {
  items: PropTypes.array,
  onHide: PropTypes.func,
  visible: PropTypes.bool,
  children: PropTypes.node.isRequired,
};

export default SideBar;
